import React from 'react';
import { View, Text } from "react-native";
import { colors, global } from "../../const";

export function MainTabicon({ title, tabIcon, active, onClick, tab, budge }) {

    return (
        <div
            style={{ backgroundColor: active ? colors.indigo : colors.white, cursor: active ? 'not-allowed' : 'pointer', width: "20%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
            onClick={() => onClick(tab)}
        >

            <View style={{
                height: 10,
                width: 10,
                borderRadius: 5,
                backgroundColor: colors.alert,
                zIndex: 1,
                position: 'absolute',
                marginTop: -17,
                marginLeft: 8,
                visibility: budge ? 'visible' : 'hidden'
            }} />

            <View>

                {tabIcon}

                <Text
                    style={{ height: 'unset', color: active ? colors.white : title === 'Reward' ? colors.disable : colors.midnightBack, fontSize: 13, fontFamily: global.FONT_REGULAR, fontWeight: 'bold', paddingTop: 5 }}
                >
                    {title}
                </Text>

            </View>
        </div>
    );

}

export function StatisticTabicon({ title, tabIcon, active, onClick, tab, budge }) {

    return (
        <div
            style={{ backgroundColor: active ? colors.indigo : colors.white, cursor: active ? 'not-allowed' : 'pointer', width: "25%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
            onClick={() => onClick(tab)}
        >

            <View style={{
                height: 10,
                width: 10,
                borderRadius: 5,
                backgroundColor: colors.alert,
                zIndex: 1,
                position: 'absolute',
                marginTop: -17,
                marginLeft: 8,
                visibility: budge ? 'visible' : 'hidden'
            }} />

            <View>

                {tabIcon}

                <Text
                    style={{ height: 'unset', color: active ? colors.white : title === 'Reward' ? colors.disable : colors.midnightBack, fontSize: 13, fontFamily: global.FONT_REGULAR, fontWeight: 'bold', paddingTop: 5 }}
                >
                    {title}
                </Text>

            </View>
        </div>
    );

}